import React from "react";

const UseCases = () => {
  return (
    <div className="bfr-use-cases-wrapper">
      <h1>Use Cases</h1>
      <div className="row">
        <div className="col-12 col-sm-6">
          <div className="card">
            <div className="title">
              <svg
                xmlns="http://www.w3.org/2000/svg"
                width="48"
                height="48"
                viewBox="0 0 16 16"
              >
                <path
                  fill="#f3792c"
                  d="M14 15V4h-3V1H2v14H0v1h7v-3h2v3h7v-1zm-8-4H4V9h2zm0-3H4V6h2zm0-3H4V3h2zm3 6H7V9h2zm0-3H7V6h2zm0-3H7V3h2zm4 6h-2V9h2zm0-3h-2V6h2z"
                />
              </svg>
              <p>Office and building access control</p>
            </div>
          </div>
        </div>
        <div className="col-12 col-sm-6">
          <div className="card">
            <div className="title">
              <svg
                xmlns="http://www.w3.org/2000/svg"
                width="48"
                height="48"
                viewBox="0 0 24 24"
              >
                <path
                  fill="#f3792c"
                  d="M15.25 2h-6.5A6.76 6.76 0 0 0 2 8.75v6.5A6.75 6.75 0 0 0 8.75 22h6.5A6.75 6.75 0 0 0 22 15.25v-6.5A6.76 6.76 0 0 0 15.25 2m5.25 10.5h-2.94l-2.7 4.52a1 1 0 0 1-.86.48h-.06a1 1 0 0 1-.86-.59L9.87 9.67l-2 3.35a1 1 0 0 1-.86.48h-3.5v-2h2.93l2.71-4.51a1 1 0 0 1 1.77.11l3.22 7.24l2-3.35a1 1 0 0 1 .86-.49h3.5z"
                />
              </svg>
              <p>Healthcare facilities for secure patient identification</p>
            </div>
          </div>
        </div>
        <div className="col-12 col-sm-6">
          <div className="card">
            <div className="title">
              <svg
                xmlns="http://www.w3.org/2000/svg"
                width="48"
                height="48"
                viewBox="0 0 256 256"
              >
                <path
                  fill="#f3792c"
                  d="M248 208a8 8 0 0 1-8 8H16a8 8 0 0 1 0-16h224a8 8 0 0 1 8 8M16.3 98.18a8 8 0 0 1 3.51-9l104-64a8 8 0 0 1 8.38 0l104 64A8 8 0 0 1 232 104h-24v64h16a8 8 0 0 1 0 16H32a8 8 0 0 1 0-16h16v-64H24a8 8 0 0 1-7.7-5.82M144 160a8 8 0 0 0 16 0v-48a8 8 0 0 0-16 0Zm-48 0a8 8 0 0 0 16 0v-48a8 8 0 0 0-16 0Z"
                />
              </svg>
              <p>Banking and FinTech for fraud prevention</p>
            </div>
          </div>
        </div>
        <div className="col-12 col-sm-6">
          <div className="card">
            <div className="title">
              <svg
                xmlns="http://www.w3.org/2000/svg"
                width="48"
                height="48"
                viewBox="0 0 50 50"
              >
                <path
                  fill="#f3792c"
                  d="M.295 27.581a6.457 6.457 0 0 0 12.805 0zM35.182 40.58a1 1 0 0 1-.998 1.003H15.528c-.548 0-1-.45-1-1.003a1 1 0 0 1 1-.993h18.655c.552 0 .999.444.999.993m-20.545 1.514h20.437v2.887H14.637zM36.9 27.581a6.46 6.46 0 0 0 6.402 5.626a6.45 6.45 0 0 0 6.399-5.626zm12.449-2.009l-5.243-7.222h2.803c.682 0 1.231-.559 1.231-1.25c0-.685-.55-1.238-1.231-1.238H32.061a7.35 7.35 0 0 0-5.634-4.732V7.233c0-.693-.556-1.246-1.245-1.246L25.066 6l-.116-.013a1.24 1.24 0 0 0-1.243 1.246v3.895a7.35 7.35 0 0 0-5.632 4.732H3.224c-.677 0-1.229.553-1.229 1.238c0 .692.552 1.25 1.229 1.25h2.675L.655 25.57H0v1.334h13.398V25.57h-.658l-5.242-7.22h12.169c0-.282.031-.559.073-.824c.043-.125.072-.252.072-.383a5.32 5.32 0 0 1 3.895-3.933v13.697h-.052c-.107 5.152-2.558 9.645-6.194 12.17h15.214c-3.637-2.525-6.086-7.018-6.199-12.17h-.048V13.21a5.32 5.32 0 0 1 3.894 3.933q.008.196.075.383c.04.266.065.542.065.824h12.042l-5.244 7.222h-.654v1.334H50v-1.334zm-43.184 0H1.98l4.185-5.765zm1.071 0v-5.765l4.185 5.765zm35.532 0h-4.187l4.187-5.765zm1.066 0v-5.765l4.19 5.765zM7.941 14.124a1.243 1.243 0 0 1-2.485 0c0-.686.558-1.246 1.245-1.246c.684-.001 1.24.56 1.24 1.246m36.604-.066c0 .691-.556 1.239-1.242 1.239a1.234 1.234 0 0 1-1.242-1.239a1.243 1.243 0 1 1 2.484 0"
                />
              </svg>
              <p>Government and law enforcement agencies</p>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default UseCases;
